import * as React from 'react';
import { IntlProvider, addLocaleData } from 'react-intl';
import * as en from 'react-intl/locale-data/en';

addLocaleData(en);

export default <P extends object>(
  WrappedComponent: React.ComponentType<P>,
  locale = navigator.language,
) => {
  return class extends React.Component<P> {
    render() {
      return (
        <IntlProvider key={locale} locale={locale}>
          <WrappedComponent {...this.props} />
        </IntlProvider>
      );
    }
  };
};
